import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Loading, Tab, Tabs } from 'carbon-components-react';
import ActiveChannel from './components/activeChannel';
import { Sandbox } from './components/sandbox';
import { currentUser } from 'redux/session/selectors';
import {
  fetchGmlProjectionStart,
  fetchReferralChannelsStart
} from 'redux/channels/actions';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectChannelsLoading,
  selectActiveChannel,
  selectDraftChannels
} from 'redux/channels';
import { ActiveChannelDataType } from 'redux/channels/types';
import { FullHeaderLeftSideFullPanelLayout } from 'layouts/fullHeader.LeftSideFullPanel.layout';
import ChannelsNoData from './components/channelsNoData';
const ReferralChannels: React.FC<RouteComponentProps<{}, any, any>> = () => {
  const dispatch = useDispatch();
  const user: any = useSelector(currentUser);
  const activeChannels: ActiveChannelDataType = useSelector(
    selectActiveChannel
  );
  const draftChannels: ActiveChannelDataType = useSelector(selectDraftChannels);

  const channelsLoading: boolean = useSelector(selectChannelsLoading);
  const [isActiveTabEnaled, setIsActiveTabEnaled] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    dispatch(fetchGmlProjectionStart());
  }, [dispatch]);

  useEffect(() => {
    if (user) {
      const organisationId = user.organisationId;
      if (organisationId) {
        dispatch(fetchReferralChannelsStart(organisationId));
      }
    }
  }, [dispatch, user]);

  useEffect(() => {
    setIsActiveTabEnaled(!!draftChannels);
  }, [draftChannels]);

  useEffect(() => {
    let isLiveActivated: boolean = false;
    if (activeChannels) {
      const { status, submitting } = activeChannels;
      isLiveActivated = status === 'LIVE' && !!submitting;
    }
    setIsLoading(channelsLoading || isLiveActivated);
  }, [channelsLoading, activeChannels]);
  return (
    <div id="referral-channels" data-testid="referral-channels">
      <FullHeaderLeftSideFullPanelLayout
        pageHeading="Referral handling"
        pageDescription="Choose how enquiries are referred to your organisation"
        enableHeaderGlobalBar={true}
      >
        <hr className="section--divider" />
        <div className="bx--col-lg-16 referral-channels--body">
          <div className="tabs-container">
            {isLoading || channelsLoading ? (
              <div className="loader--wrapper">
                <Loading
                  description="Active loading indicator"
                  withOverlay={false}
                />
              </div>
            ) : (
              <Tabs
                selected={isActiveTabEnaled ? 1 : 0}
                selectionMode={'automatic'}
              >
                <Tab
                  onClick={() => setIsActiveTabEnaled(false)}
                  id="active-channel"
                  label="Active channel"
                >
                  <div className="activeChannel--tabContent">
                    {activeChannels ? (
                      <ActiveChannel
                        clickSandboxHandler={() => setIsActiveTabEnaled(true)}
                      />
                    ) : (
                      <ChannelsNoData
                        onClickSandboxHandler={(val: boolean) =>
                          setIsActiveTabEnaled(val)
                        }
                      />
                    )}
                  </div>
                </Tab>
                <Tab
                  id="sandbox"
                  label="Sandbox"
                  onClick={() => setIsActiveTabEnaled(true)}
                >
                  <div className="sandbox--tabContent">
                    <Sandbox />
                  </div>
                </Tab>
              </Tabs>
            )}
          </div>
        </div>
      </FullHeaderLeftSideFullPanelLayout>
    </div>
  );
};
ReferralChannels.displayName = 'ReferralChannelsModule';

export default React.memo(ReferralChannels);
